export enum SettingsSubtypeEnum {
  TrackingGA = 'trackingGA',
  TrackingGTM = 'trackingGTM',
  TrackingHotjar = 'trackingHotjar',
  TrackingFbPixel = 'trackingFbPixel',
  TrackingConsent = 'trackingConsent',
}
